module.exports = __webpack_public_path__ + "img/oil_paint_large_6.ce4ee3c3.png";